import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth';

export enum OnboardingStep {
  CreateAccount = 'create-account',
  CompanySetup = 'company-setup',
  CreatePortal = 'create-portal',
}

export interface OnboardingPageQueryParams {
  assembly?: true;
  referred?: string;
  source?: string;
  prefill_email?: string;
  step?: OnboardingStep;
  name?: string;
  email?: string;
  nextOnboardingStep?: OnboardingStep;
  authSource?: CognitoHostedUIIdentityProvider;
  template_id?: string;
  template_name?: string;
}
